var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthconfig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.169,
    height: 18.558,
    viewBox: "0 0 16.169 18.558",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "authentication-29",
    transform: "translate(-124.226 -66.74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3074",
    "data-name": "Path 3074",
    d: "M140.291,69.528l-.79-.012a11.8,11.8,0,0,1-3.62-.748,16.269,16.269,0,0,1-3.1-1.576l-.476-.331-.475.331a16.312,16.312,0,0,1-3.1,1.576,11.761,11.761,0,0,1-3.616.748l-.795.012v7.708c0,3.87,5.192,7.962,7.984,7.962s7.985-4.091,7.985-7.962l0-7.708Zm-7.982,14.525c-2.319,0-6.84-3.68-6.84-6.817V70.645a13,13,0,0,0,3.681-.809,18.4,18.4,0,0,0,3.159-1.587,17.863,17.863,0,0,0,3.156,1.587,13.054,13.054,0,0,0,3.681.809l0,6.591c0,3.137-4.522,6.817-6.841,6.817Z",
    transform: "translate(0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3075",
    "data-name": "Path 3075",
    d: "M489,540.487l-3.061,3.058-1.283-1.455a.572.572,0,1,0-.858.757l1.685,1.912a.571.571,0,0,0,.411.192h.018a.571.571,0,0,0,.4-.167l3.492-3.487a.573.573,0,0,0-.809-.811Z",
    transform: "translate(-351.932 -463.708)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3076",
    "data-name": "Path 3076",
    d: "M294.861,291.669a11.087,11.087,0,0,1,.844-.768,4.163,4.163,0,0,0-1.369-.962,2.645,2.645,0,1,0-3.224,0,4.1,4.1,0,0,0-2.483,3.765.572.572,0,1,0,1.144,0,2.946,2.946,0,0,1,5.088-2.031Zm-2.134-5.314a1.5,1.5,0,1,1-1.5,1.5,1.5,1.5,0,0,1,1.5-1.5Z",
    transform: "translate(-160.919 -213.852)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthconfig);
export default __webpack_public_path__ + "static/media/authconfig.5825bdd1186dd9bd5c86f545db026bc8.svg";
export { ForwardRef as ReactComponent };